<div class="container">
  <h1 class="mb-4">
    Buy Now
  </h1>
  <div>
    The Aqaix API Store is available today in three configurations.

    <h2 class="mt-4">
      Host your APIs at the Aqaix API Store
    </h2>
    <div>
      It's easy and simple to put your REST APIs into the Aqaix API Store.
      There you can log in and control access to your data by choosing OAuth 2.0 security models,
      as well as implement monetization, rate limiting, and other policies.
    </div>

    <h2 class="mt-4">
      Your Own API Store
    </h2>
    <div>
      It's easy to obtain your own custom API Store, branded with your company's logo and with a custom URL.
      You completely control who can access this API Store, and enjoy all the features and functionality of the Aqaix API Store.
    </div>

    <h2 class="mt-4">
      On Premise Configurations
    </h2>
    <div>
      The Aqaix API Store can be deployed into your data center, colo, or cloud partition (GCP, Azure, AWS, or other).
      You can manage it directly behind your firewall, and can configure network and other security as you see fit.
    </div>
  </div>

  <div class="mt-5 text-center"
       style="font-size: 1.4rem;">
    Contact us now for a quotation!
    <div>
      <small>
      Email <a href="mailto:info@aqaix.com">info@aqaix.com</a>
      </small>
    </div>
  </div>
</div>
